import { render, staticRenderFns } from "./CompButtonOutlineRed.vue?vue&type=template&id=b639e2ca&scoped=true"
import script from "./CompButtonOutlineRed.vue?vue&type=script&setup=true&lang=js"
export * from "./CompButtonOutlineRed.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompButtonOutlineRed.vue?vue&type=style&index=0&id=b639e2ca&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639e2ca",
  null
  
)

export default component.exports